import { Route, Switch, useRouteMatch } from 'react-router';

import FilterCreate from './FilterCreate';
import FiltersList from './FiltersList';

const FiltersPage = (props) => {
    let { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/create`}>
                <FilterCreate {...props} />
            </Route>
            <Route path={`${path}/:id/preview`}>
                <FiltersList {...props} />
            </Route>
            <Route exact path={path}>
                <FiltersList {...props} />
            </Route>
        </Switch>
    );
};

export default FiltersPage;
